import { render } from "./submissions-table-row-placeholder.vue?vue&type=template&id=22d07218&scoped=true&ts=true"
import script from "./submissions-table-row-placeholder.vue?vue&type=script&lang=ts"
export * from "./submissions-table-row-placeholder.vue?vue&type=script&lang=ts"

import "./submissions-table-row-placeholder.vue?vue&type=style&index=0&id=22d07218&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d07218"]])

export default __exports__